import React from 'react'
import ErrorPage from 'pages/DefaultErrorPage/DefaultErrorPage'

import reload from 'utils/reload'
import Mark from 'assets/mark.svg'

const OnLoadError = () => {
  return (
    <ErrorPage
      img={{
        src: Mark,
        alt: 'Aviso',
      }}
      action="Erro ao carregar página"
      body="Encontrei uma instabilidade para carregar minha página, mas já notifiquei o time técnico para resolver isso. Que tal tentar novamente em breve?"
      button={{
        text: 'Recarregar a página',
        onClick: () => reload(),
      }}
    />
  )
}

export default OnLoadError
